export enum CollegeType {
  Unique = 'Collège Unique',
  Premier = '1er Collège: ouvriers, employés',
  Deuxieme = '2ème Collège: techniciens, agents de maîtrise, ingénieurs et cadres',
  Troisieme = '3ème Collège: ingénieurs et cadres',
  Autre = 'Autre Collège'
}

export enum LineupOptions {
  Workers = 'Ouvriers',
  Employees = 'Employés',
  Technicians = 'Techniciens',
  Supervisors = 'Agent de maîtrise',
  Engineers = 'Ingénieurs',
  Executives = 'Cadres',
  Other = 'Autres'
}

export interface ElectionVenue {
  legalName: string;
  legalForm: string;
  capital: string;
  rcs: string;
  address: string;
  siret: string;
  zipcode: string;
  city: string;
  idcc: string;
}

export interface ElectionInformation {
  partial: boolean;
  duration: number[];
  colleges: number;
  date: Date;
}

export interface ElectionContext {
  cancelled: boolean;
  cancellationDate: Date;
  setup: boolean;
  expirationDate: Date;
  noQuorum: boolean;
  previousElectionId: string;
}

export interface PreviousElection {
  previousElectionDate: Date;
  hasSameSiret: boolean;
  siret: string;
}

export interface ElectionSirets {
  sirets: string[];
}

export interface ElectionColleges {
  collegeType: CollegeType[];
  collegeName: string;
  genderDistribution: number[];
  seats: number;
  lineup: number;
  substituteSeats: number;
  composition: LineupOptions[];
  proportion: number[];
  substituteProportion: number[];
  detail: string;
  cancelledElection: Date;
}

// export interface VotingPeriod {
//   fRLimit: Date;
//   fROpening: Date;
//   fRClosing: Date;
//   sRLimit: Date;
//   sROpening: Date;
//   sRClosing: Date;
// }

export interface ElectionContact {
  name: string;
  firstName: string;
  occupation: string;
  mail: string;
  phone: string;
}

// Note: For new PAP, lookalike ElectionContact
export interface EmployerContact {
  man: boolean;
  name: string;
  firstName: string;
  role: string;
}

export interface Union {
  man: boolean;
  unionName: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface CommonList {
  listName: string;
  listMembers: string;
  listMembersFullName: string;
  composition: number;
}

export interface Round {
  firstRound: boolean;
  shortage: boolean;
}

export interface TermLength {
  partial: boolean;
  duration: number[];
}

export interface VotingPeriod {
  fROpening: Date;
  fRClosing: Date;
  sROpening: Date;
  sRClosing: Date;
}

export interface HeadCount {
  total: number;
  fullMembers: number;
  numberOfColleges: number;
}

export interface Application {
  mailOption: boolean;
  address: string;
  zip: string;
  city: string;
  emailOption: boolean;
  emailAddress: string;
  handOption: boolean;
  firstName: string;
  lastName: string;
  firstRoundLimit: Date;
  secondRoundLimit: Date;
}

export interface PAP {
  title: string;
  venue: ElectionVenue;
  informations: ElectionInformation;
  context: ElectionContext;
  previous: PreviousElection;
  sirets: ElectionSirets;
  colleges: ElectionColleges[];
  period: VotingPeriod;
  contact: ElectionContact;
  employer: EmployerContact;
  unions: Union[];
  termLength: TermLength;
  headcount: HeadCount;
  application: Application;
  electionYear: number;
  commonLists: CommonList[];
  round: Round;
  draftId: string;
}
